var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2307_16247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.622396 14.5409C0.621711 17.014 1.26792 19.4289 2.49667 21.5573L0.504883 28.8297L7.94722 26.8783C10.0057 27.9988 12.312 28.586 14.6557 28.5862H14.6619C22.3989 28.5862 28.697 22.2904 28.7004 14.552C28.7018 10.8021 27.2429 7.27607 24.5921 4.62325C21.9418 1.97065 18.4169 0.509036 14.6613 0.507324C6.92338 0.507324 0.625704 6.80283 0.62251 14.5409",
    fill: "url(#paint0_linear_2307_16247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.1211 14.5364C0.120301 17.0986 0.789669 19.5998 2.06223 21.8044L-0.000976562 29.3375L7.70822 27.3162C9.83235 28.4743 12.2239 29.0849 14.6575 29.0858H14.6637C22.6783 29.0858 29.2027 22.5635 29.2061 14.5481C29.2075 10.6635 27.696 7.0107 24.9506 4.26284C22.2048 1.51532 18.5539 0.00110898 14.6637 -0.000488281C6.64775 -0.000488281 0.124295 6.52091 0.1211 14.5364ZM4.71221 21.4248L4.42436 20.9678C3.21432 19.0438 2.57564 16.8204 2.57655 14.5374C2.57906 7.87505 8.00109 2.45474 14.6683 2.45474C17.8971 2.4561 20.9314 3.71475 23.2137 5.99838C25.4958 8.28224 26.7516 11.3182 26.7508 14.5472C26.7478 21.2095 21.3257 26.6305 14.6637 26.6305H14.6589C12.4897 26.6293 10.3623 26.0468 8.50696 24.9459L8.06544 24.6841L3.49064 25.8835L4.71221 21.4248Z",
    fill: "url(#paint1_linear_2307_16247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0272 8.45807C10.755 7.85305 10.4685 7.84084 10.2096 7.83023C9.99762 7.8211 9.75529 7.82179 9.51319 7.82179C9.27087 7.82179 8.87714 7.91295 8.54434 8.27632C8.2112 8.64004 7.27246 9.519 7.27246 11.3067C7.27246 13.0944 8.57457 14.8221 8.75609 15.0648C8.93784 15.307 11.2698 19.093 14.9632 20.5495C18.0327 21.7599 18.6573 21.5191 19.3235 21.4584C19.9898 21.398 21.4734 20.5797 21.7761 19.7312C22.079 18.8828 22.079 18.1556 21.9882 18.0037C21.8973 17.8523 21.655 17.7613 21.2916 17.5797C20.9283 17.3981 19.1417 16.5189 18.8087 16.3976C18.4756 16.2765 18.2333 16.216 17.991 16.5798C17.7487 16.9431 17.0528 17.7613 16.8408 18.0037C16.6289 18.2466 16.4168 18.2768 16.0535 18.095C15.6899 17.9127 14.5197 17.5295 13.1313 16.2917C12.0511 15.3286 11.3219 14.1392 11.1099 13.7754C10.8979 13.4121 11.0872 13.2152 11.2694 13.0341C11.4326 12.8713 11.6329 12.6098 11.8147 12.3977C11.9959 12.1855 12.0564 12.0341 12.1775 11.7918C12.2988 11.5492 12.2381 11.337 12.1474 11.1553C12.0564 10.9735 11.3503 9.1765 11.0272 8.45807Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2307_16247",
    x1: 1410.28,
    y1: 2832.74,
    x2: 1410.28,
    y2: 0.507324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2307_16247",
    x1: 1460.35,
    y1: 2933.8,
    x2: 1460.35,
    y2: -0.000488281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2307_16247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.2071,
    height: 29.4353,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.5ba72918da81f348d15de5072af19d7d.svg";
export { ForwardRef as ReactComponent };